import axios from 'axios';

const fetchAppSettings = () => {
	const envUrl = '/env.json';
	// TODO: move it to env.json
	const TOLGEE_SETTINGS = {
		API: {
			URL: 'https://tolgee.k8s.k3paykassma.com',
			key: 'tgpak_gvptgy3rn53gm5leheztomjrgiygi3zvgbtw4obrg5zhk',
		},
		projectId: '5',
		languages: 'en,ru',
	};

	return axios
		.get(envUrl)
		.then((resp) => {
			if (resp.status === 200 && resp.data) {
				return resp.data;
			}

			throw new Error('App config loading error');
		})
		.then((config) =>
			axios
				.get(
					`${TOLGEE_SETTINGS.API.URL}/v2/projects/${TOLGEE_SETTINGS.projectId}/translations/${TOLGEE_SETTINGS.languages}?structureDelimiter`,
					{
						headers: {
							'x-api-key': TOLGEE_SETTINGS.API.key,
						},
					},
				)
				.then((i18nResp) => {
					if (
						i18nResp.status === 200 &&
						Object.keys(i18nResp.data).length >= 1
					) {
						return { translations: i18nResp.data, config };
					}

					throw new Error('Tolgee locales loading error');
				}),
		)
		.catch((e) => {
			console.error(e);
		});
};

export default fetchAppSettings;
